<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 col-lg-4">
						<h4 class="mm-0 mb-4">Agencies <router-link :to="{ name : user_role+'.organizations.create'}" tag="a" class="ml-2 button buttton-small small-button">
							    	<img src="../../../assets/images/icons/solid/plus_white.svg" width="14" />
									new
								</router-link></h4>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
		</div><!--row-->
		<div class="row">
			<div class="col-12 col-xl-7">
				<div class="row justify-content-between align-items-end mb-2">
					<div class="col-12 col-lg-5">
						<div class="input-content no-border m-0 ml-2">
							<input v-model="search" placeholder="Search by name" type="text" @keyup="getOrganizations()" />
						</div>
						
					</div><!--col-->
					<div class="col-12 col-lg-5">
						<multiselect v-model="per_page" :options="[10, 25, 50, 100]" @select="changePerPage"
							:allow-empty="false" :show-labels="false"></multiselect>
					</div><!--col-->
				</div><!--row-->
				<div class="table-responsive">
		
					<table class="table table-bordered">
						<thead>
							<tr>
								<th class="green-content orderable">Name<span class="sorting"><span class="asc"></span><span class="desc"></span></span></th>
								<th class="green-content">Nº HHAs</th>
								<th class="green-content">Year founded</th>
								<th class="width-150 text-center green-content">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in organizations" >
								<td><router-link :to="{ name: 'csm.providers.list', params : { agency_id : item.id }}" tag="a" class="bold">{{ item.name }} 
									<template v-if="item.code"><small> | {{ item.code }}</small></template>
								</router-link></td>
								<td>{{ item.n_providers }} </td>
								<td>{{ item.year_founded }}</td>
								<td class="text-center">
									<div class="trigger-hidden-content ml-1 d-inline-block">
										<span class=" button">
											<img width="15" src="../../../assets/images/icons/solid/ellipsis-h_white.svg">
										</span>
										<div class="hidden-content hc-right-bottom">
											<div>
												<ul class="list-unstyled text-left">
													<li class=" d-flex align-items-center cursor-pointer">
														<router-link :to="{ name: user_role+'.organizations.detail', params : { id : item.id } }" tag="a" class="pb-2 pt-2 d-block w-100">
											<img width="5" class="mr-1 ml-1" src="../../../assets/images/icons/solid/info.svg" /> View details
										</router-link>
													</li>
				      				
													
													<li class=" d-flex align-items-center cursor-pointer" >
														<router-link :to="{ name : user_role+'.organizations.imports.index', params : { id : item.id } }" tag="a" class="pb-2 pt-2 d-block w-100">
															<img width="12" class="mr-1" src="../../../assets/images/icons/solid/upload.svg">
															<span>Imports</span>
														</router-link>
													</li>
													<li class=" d-flex align-items-center cursor-pointer" >
														<router-link :to="{ name : user_role+'.organizations.import', params : { id : item.id } }" tag="a" class="pb-2 pt-2 d-block w-100">
															<img width="12" class="mr-1" src="../../../assets/images/icons/solid/upload.svg">
															<span>Import HHAs</span>
														</router-link>
													</li>
													<li v-if="user_role != 'csm'" class="pb-2 pt-2 d-flex align-items-center  cursor-pointer"  @click="showModalDelete(item)">
														<img width="12" class="mr-2" src="../../../assets/images/icons/solid/trash.svg">
														<span> Delete</span>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="row justify-content-between ">
					<div class="col-12 col-lg-6">
						<span>Showing {{ from }} to {{ to }} of {{ total_rows }}</span>
					</div><!--col-->
					<div class="col-12 col-lg-6">
						<b-pagination align="right" :total-rows="total_rows" v-model="current_page"  @change="setPage" :per-page="parseInt(per_page)">
				    	</b-pagination>
					</div><!--col-->
				</div><!--row-->
		
		    	<b-modal v-model="show_delete" title="Delete Agency" @ok="deleteOrganization" cancel-title="No" ok-title="Yes">
			    	<div v-if="organization_to_delete != null">
						<p class="mb-2">
							Are you sure you want to delete the agency {{ organization_to_delete.name }}?
						</p>
					</div>
				</b-modal>
				
			</div><!--col-->

			<!--
			<div class="col-12 col-lg-5">
				<admin-lhcsa-dashboard-chart-1  class="w-100" />
			</div><!--col-->
		</div><!--row-->
	</div><!--container-->
</template>

<script>
	export default {
		data : function(){
			return {
				current_page : 1,
				total_rows : 15,
				per_page  : 50,
				from : 0,
				to : 0,
				organizations : [],
				organization_to_delete : null,
				show_delete : false,
				search: '',
				user_role: '',
				router_names:''
			}
		},
		created : function(){
			this.getOrganizations();
			console.log(this.$store.getters.getRole) //csm
			this.user_role = this.$store.getters.getRole
		},

		methods : {

			getOrganizations : function() {
				var params = {
					filters : {
						page : this.current_page,
						per_page : this.per_page,
						search: this.search,
						page_loading: false
					}
				}
				
				this.$store.dispatch('getOrganizations', params).then((res) => {
					
					this.organizations = res.data.data;

					this.current_page = res.data.meta.current_page;
					this.total_rows = res.data.meta.total;
					this.per_page = parseInt(res.data.meta.per_page);
					this.from = res.data.meta.from;
					this.to = res.data.meta.to;
				}).catch((error) => {
					console.log(error);
				});
			},
			setPage : function(page){
				this.current_page = page;

				this.getOrganizations();
			},
			showModalDelete : function(organization){
				this.organization_to_delete = organization;
				this.show_delete = true;
			},
			deleteOrganization : function(){
				var params = {
					id : this.organization_to_delete.id
				}

				this.$store.dispatch('deleteOrganization', params).then((res) => {
					console.log(res);
					this.organization_to_delete = null;
					this.show_delete = false;
					this.getOrganizations();
				}).catch((error) => {
					console.log(error);
					this.show_delete = false;
				});
			},
			getSignUps : function(){
	
				var params = {
					filters : {}
				}
	
				this.$store.dispatch('getSignUps', params).then((res) => {
					console.log(res);
				}).catch((error) => {
					console.log(error);
				});
			},
			changePerPage : function(value, id){

				this.current_page = Math.ceil(this.from/value);

				this.per_page = value;
				this.page_loading = false;
				this.getOrganizations();
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/admin/organization/AdminOrganizationListComponent.vue